import { IPagedResult } from '../../global/generics';
import { IRepasseService } from '../@types/services';
import { IApiResponse, ITecpayApi } from '../providers/types';
import {
  IAllRepasses,
  IRepassesFilterProps,
  IDetalhesRepassesFilterProps,
  IDetailsRepasseDto,
  ITransferenciaRepassesDto,
  IStatisticsBusinessDto,
} from '../../global/dataTransferObjects/repasses';
import { IAppState } from '../../store/types';

const repassesService = (apiProvider: ITecpayApi): IRepasseService => {
  const getAllRepasses = async (
    offset: number,
    pageSize: number,
    filter?: IRepassesFilterProps,
    userStateCompany?: IAppState,
  ): Promise<IApiResponse<IPagedResult<IAllRepasses>>> => {
    const startDate = filter?.startDate || null;
    const finishDate = filter?.finishDate || null;
    const businessId = filter?.businessId || null;
    if (userStateCompany?.user.userInfo.userType !== 3 && userStateCompany?.company.selectedCompany.id.length !== 0) {
      const response = await apiProvider
        .createRequest<IPagedResult<IAllRepasses>>({ url: 'transacoes/repasses' })
        .withSearch({
          offset,
          pageSize,
          startDate,
          finishDate,
          businessId: userStateCompany?.company.selectedCompany.id,
        })
        .sendAsync();

      return response;
    }
    const response = await apiProvider
      .createRequest<IPagedResult<IAllRepasses>>({ url: 'transacoes/repasses' })
      .withSearch({
        offset,
        pageSize,
        startDate,
        finishDate,
        businessId,
      })
      .sendAsync();

    return response;
  };

  const getDetalhesRepasses = async (
    offset: number,
    pageSize: number,
    businessIdentification: string,
    filter?: IDetalhesRepassesFilterProps,
  ): Promise<IApiResponse<IPagedResult<IDetailsRepasseDto>>> => {
    const startDate = filter?.startDate || null;
    const finishDate = filter?.finishDate || null;
    const businessId = businessIdentification || filter?.businessId || null;
    const onlyPayed = filter?.onlyPayed || false;
    const onlyNotPayed = filter?.onlyNotPayed || false;
    const productType = filter?.productType || null;
    const response = await apiProvider
      .createRequest<IPagedResult<IDetailsRepasseDto>>({ url: 'transacoes/repasses/detalhes' })
      .withSearch({
        offset,
        pageSize,
        startDate,
        finishDate,
        businessId,
        onlyPayed,
        onlyNotPayed,
        productType,
      })
      .sendAsync();

    return response;
  };

  const getTransferenciasRepasses = async (
    offset: number,
    pageSize: number,
    filter?: IDetalhesRepassesFilterProps,
  ): Promise<IApiResponse<IPagedResult<ITransferenciaRepassesDto>>> => {
    const startDate = filter?.startDate || null;
    const finishDate = filter?.finishDate || null;
    const response = await apiProvider
      .createRequest<IPagedResult<ITransferenciaRepassesDto>>({ url: 'transacoes/repasses/transferencias' })
      .withSearch({
        offset,
        pageSize,
        startDate,
        finishDate,
      })
      .sendAsync();

    return response;
  };

  const getStatisticsBusiness = async (
    businessId: string,
  ): Promise<IApiResponse<IPagedResult<IStatisticsBusinessDto>>> => {
    const response = await apiProvider
      .createRequest<IPagedResult<IStatisticsBusinessDto>>({ url: 'transacoes/repasses/transferencias/estatisticas' })
      .withSearch({
        businessId,
      })
      .sendAsync();

    return response;
  };

  return ({
    getAllRepasses,
    getDetalhesRepasses,
    getTransferenciasRepasses,
    getStatisticsBusiness,
  });
};

export default repassesService;
